<body>
    <div class="forgot-password-container">
        <div class="col-md-6 col-lg-5 d-none d-md-block triangle">
            <img src="../../../../assets/logo/EMP.png" alt="login form" class="img-fluid" style="margin-left: 94px;" />
        </div>
        <h2>Vendor Forgot Password</h2>
        <p>No worries! Enter your email, and we'll send you an OTP.</p>
        <form id="forgotPasswordForm" (ngSubmit)="submit(forgotPasswordForm)" #forgotPasswordForm="ngForm">
            <input type="email" [(ngModel)]="mailId" name="mailId" placeholder="Enter your email" required email
                #emailInput="ngModel" />
            <div *ngIf="emailInput.invalid && emailInput.touched" class="error-message">
                Please enter a valid email.
            </div>
            <button type="submit" [disabled]="forgotPasswordForm.invalid || isLoading">
                {{ isLoading ? 'Sending...' : 'Send OTP' }}
            </button> 
        </form>
        <a href="/vendor-login">Back to Login</a>
    </div>
</body>